import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { FullTable, MultipleSelect, SearchInput, TableWrapper, UserInputsDropdown } from 'components';
import { officeActions, vendorProspectsActions } from 'store';
import { ACTION_TYPE_DELETE, ACTION_TYPE_GET, vendorProspectsBody, vendorProspectsHeader } from './fragments/constants';
import { PermissionsList, RolePermission, SavePage, useModal } from 'utils';
import { CreateVendorProspect } from './fragments';
import { CustomDeleteModal } from '../../fragments';
import { vendorEnums } from '../vendors';
import { vendorModesEnums, vendorStatusesEnum, vendorTypes } from '../vendors/fragments/constants';
import { carrierStatuses, carrierStatusesNoPending } from '../vendors/constants';


export const VendorProspects = () => {
  const { vendorProspects } = useSelector((state) => ({
    vendorProspects: state.vendorProspects.vendorProspects,
  }));
  const dispatch = useDispatch();
  const history = useHistory();
  const { open } = useModal();
  const info = history?.location?.state;

  useEffect(() => {
    if(RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.READ_OFFICE?.code, PermissionsList.CREATE_UPDATE_OFFICE?.code], 'officeManager')) {
      dispatch(officeActions.getOffices({ status: 'ACTIVE' }));
    }
  }, []);



  const renderParams = () => {
    const params = {
      ...info,
    };
    params.skip = info?.skip ? info?.skip : 0;
    params.limit = 100;
    params.page = info?.page ? info?.page : 1;

    params?.vendorTypes?.length ? params.vendorTypes = info?.vendorTypes?.map((i) => i?.id) : delete params.vendorTypes;
    params.modes?.length ? params.modes = info?.modes?.map((i) => i?.id) : delete params.modes;

    delete params.page;
    delete params.activeTab;
    return params;
  };

  const getVendorProspects = (loading) => {
    dispatch(vendorProspectsActions.getVendorProspects(renderParams(), loading));
  };

  useEffect(() => {
    getVendorProspects();
  }, [info]);

  const handleCLick = (item, name) => {
    if (name === 'edit') {
      open(<CreateVendorProspect
        info={item}
        afterSuccess={() => {
          getVendorProspects('noLoad');
        }}
      />);
    }
    if (name === 'delete') {
      open(
        <CustomDeleteModal
          actionType={ACTION_TYPE_DELETE}
          text="Delete Vendor?"
          modalText="Deleting this vendor will remove all associated information.This action cannot be undone."
          handleDel={() => {
            dispatch(vendorProspectsActions.deleteVendorProspects(item?.id));
          }}
          afterSuccess={() => {
            getVendorProspects('noLoad');
            close();
          }}
        />,
      );
    }
  };

  const handleChange = (value, name) => {
    const params = {
      ...info,
    };
    params.limit = 100;
    params.skip = 0;
    params.page = 1;
    if (value) {
      params[name] = value;
    } else {
      delete params[name];
    }
    SavePage(history, info, { ...params });
  };


  return (
    <div className="vendor-prospects-page">
      <TableWrapper
        addButton="Add Vendor"
        buttonsTabAddButton={true}
        buttonsTab={true}
        tab={'none'}
        handleClick={() => open(<CreateVendorProspect afterSuccess={() => getVendorProspects('noLoad')} />)}
        createPermisson={PermissionsList.MANAGE_VENDOR_PROSPECTS}
        type="officeOrBranchManager"
      >
        <div className='flex-align-center' style={{gap: 16, marginTop: '-34px'}}>
          <MultipleSelect
            selectedList={info?.vendorTypes}
            handleChange={(value) => handleChange(value, 'vendorTypes')}
            permissionsList={vendorTypes}
            label={'Vendor Type'}
            renderName={(item) => item?.name}
            smallSize={true}
          />
          <MultipleSelect
            selectedList={info?.modes}
            handleChange={(value) => handleChange(value, 'modes')}
            permissionsList={vendorModesEnums}
            label={'Modes'}
            renderName={(item) => item?.name}
            smallSize={true}
          />
          <SearchInput
            // className={filterClasses.searchByContainer}
            name="serviceArea"
            placeholder="Service Area"
            saveParams={info}
            defaultStyles={true}
          />
        </div>
        <FullTable
          head={vendorProspectsHeader}
          body={vendorProspectsBody}
          loadingType={ACTION_TYPE_GET}
          list={vendorProspects?.vendorProspects}
          listCount={vendorProspects?.count}
          handleClickButton={handleCLick}
          noText={'Vendor Prospects'}
        />
      </TableWrapper>
    </div>
  );
};

